export enum UBXTabsDirection {
    Horizontal = 0,
    Vertical = 1,
}
